import removeDuplicates from './removeDuplicates'

const keyFn = item => item.timestamp.toISOString()
const sortDates = (a, b) => {
  return new Date(a.timestamp) - new Date(b.timestamp)
}

const transformData = json => {
  const data = json.features
    .filter(item => item.properties.timestamp)
    .map(item => ({
      ...item.properties,
      iceTemperature: +item.properties.tice_mean,
      iceThickness: -+item.properties.ice_thickness,
      snowDepth: +item.properties.snow_depth,
      timestamp: new Date(item.properties.timestamp)
    }))

  return removeDuplicates(keyFn, data).sort(sortDates)
}

export default transformData



// WEBPACK FOOTER //
// ./src/utility/transformData.js